import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's arc and which way it faces. */
export const WavePatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="wave"
    width={{ value: "12.5", min: 5, max: 40, labelKey: "TILE_WIDTH" }}
    height={{ value: "12.5", min: 5, max: 40, labelKey: "TILE_HEIGHT" }}
  />
);
